module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e32410"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Morg_9781550924589_epub_c5_r1#d7e2178",
      "id": "d14e212"
    }
  }, [_vm._v("acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e32910"
    }
  }, [_c('span', [_vm._v("A lifetime of cooking and gardening with friends and family could make this list as long as the book itself, but there are some people I particularly want to thank. Carolyn Dale and Tim Pilgrim, for kiwis, rhubarb, and great meals; Mary Jean Wiegert and Bruce Underwood for rutabagas and a memorable evening in their fabulous kitchen; Robert (Goldtooth) Ray, for taste testing both the successes and the stranger experiments; Mark Musick, Bruce Naftaly, Jon Kemnitzer, Deb Anderson-Frey, Marilyn Lewis, Gale Lawrence, Bill Bowes, and Kristen Barber for recipes and encouragement; Curt Madison, for 40+ years of friendship and that moose roast; Bruce Brown, for Sumas days and for reminding me about my garden journals; my friend and agent Anne Depue; and my family—Deshanna Brown, Laurel, Ronny and Hailey Tull, and Andrew Tull—for loving me.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb81a832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c6_r1.vue
// module id = 75
// module chunks = 0